import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageFooter from "@Shared/components/general/page-footer.vue";
import PublicSessionTerminated from "./public-session-terminated.vue";
import { defineComponent } from "@vue/composition-api";
import { LICENSE_TYPE } from "@Client/@Utils/enums";
import { mapState } from "vuex";
import { isEmpty } from "lodash";
import { logout } from "@Client/@Modules/main/api/account-api";
export default defineComponent({
  name: "AppSidebar",
  components: {
    PageFooter,
    PublicSessionTerminated
  },
  props: {
    id: {
      type: String,
      default: "light-weight-app"
    },
    sidebar: {
      type: Boolean,
      default: true
    },
    agentAccountDetails: {
      type: Object,
      required: true
    },
    logo: {
      type: [String, Object],
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    sideClass: {
      type: String,
      default: ""
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    showAgentLicenseNumber: {
      type: Boolean,
      default: false
    },
    clientSignup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      sessionTerminated: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationStandaloneStore", ["currentApplicationId"])), {}, {
    licenseType() {
      var _this$agentAccountDet, _this$agentAccountDet2, _this$agentAccountDet3, _this$agentAccountDet4;
      return (_this$agentAccountDet = this.agentAccountDetails) != null && _this$agentAccountDet.licenseType && ((_this$agentAccountDet2 = this.agentAccountDetails) == null ? void 0 : _this$agentAccountDet2.licenseType) !== "blank" && LICENSE_TYPE[(_this$agentAccountDet3 = this.agentAccountDetails) == null ? void 0 : _this$agentAccountDet3.licenseType] ? this.$t(`global.licenseTypes.${LICENSE_TYPE[(_this$agentAccountDet4 = this.agentAccountDetails) == null ? void 0 : _this$agentAccountDet4.licenseType]}`) : null;
    },
    allowLogout() {
      return !isEmpty(this.currentApplicationId);
    }
  }),
  watch: {
    agentAccountDetails(value, oldValue) {
      if (!oldValue.email) return;
      this.sessionTerminated = !value.email || value.email !== oldValue.email;
    }
  },
  methods: {
    async handleLogout() {
      var _this$$auth, _this$$auth$session, _this$$auth$session$g, _this$$auth$session$g2;
      const token = (_this$$auth = this.$auth) == null ? void 0 : (_this$$auth$session = _this$$auth.session) == null ? void 0 : _this$$auth$session.get == null ? void 0 : (_this$$auth$session$g = _this$$auth$session.get()) == null ? void 0 : (_this$$auth$session$g2 = _this$$auth$session$g.xData) == null ? void 0 : _this$$auth$session$g2.ref;
      try {
        if (token) {
          await logout(token);
        }
      } catch (e) {
        console.error("Logout failed", e);
      }
      this.$router.replace({
        name: "login"
      });
      await this.$nextTick();
      this.$auth.session.end();
    }
  }
});